import { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";

import NotificationsCommandBar from "../../command-bar/NotificationsCommandBar";
import NotificationsPage from "../pages/NotificationsPage";

import useAbortSignal from "../../hooks/useAbortSignal";
import { useAppData } from "../../context/AppDataContext";

const NotificationsContainer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({ new: [], cleared: [] });
  const { signal } = useAbortSignal();
  const { api, refreshNotificationCount } = useAppData();

  const fetchNotifications = async () => {
    try {
      const result = await api.notification.getNotifications();

      setData(result ?? []);
      setIsLoading(false);
    } catch (err) {
      console.error("Get Notifications:", err);
    }
  };

  const handleClearNotification = async (notificationId) => {
    if (!data?.new?.length) return;

    const body = {
      notification_id: notificationId,
      notification_ids: !notificationId
        ? data.new.map((n) => n.notification_id)
        : null,
    };

    try {
      await api.notification.clearNotifications(body);
      setData((prev) => {
        if (notificationId) {
          const movedNotification = prev.new.find(
            (n) => n.notificationId === notificationId
          );
          return {
            new: prev.new.filter(
              (n) => n.new.notificationId !== notificationId
            ),
            cleared: [...prev.cleared, movedNotification],
          };
        } else {
          return {
            new: [],
            cleared: [...prev.cleared, ...prev.new],
          };
        }
      });
      await refreshNotificationCount();
    } catch (err) {
      console.error("Notification Clear:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [signal]);

  return (
    <div className="notifications-container">
      <Route
        path="/notifications"
        render={() => (
          <NotificationsCommandBar
            handleClearNotification={handleClearNotification}
          />
        )}
      />

      <Switch>
        <Route
          path="/notifications/new"
          render={() => (
            <NotificationsPage
              data={data?.new || []}
              isLoading={isLoading}
              handleClearNotification={handleClearNotification}
            />
          )}
        />

        <Route
          path="/notifications/cleared"
          render={() => (
            <NotificationsPage
              data={data?.cleared || []}
              isLoading={isLoading}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default NotificationsContainer;
